import React, { useEffect, useState } from 'react'
import { navigate } from 'gatsby'
import imgBasePenis from '../../../assets/images/basePersonajePenis.png'
import imgBaseMenstruacion from '../../../assets/images/basePersonajeMenstruacion.png'
import imgBaseZonaV from '../../../assets/images/basePersonajeZonaV.png'
import imgPersonajeMenstruacion from '../../../assets/images/personajeMenstruacion.png'
import imgPersonajePenis from '../../../assets/images/personajePenis.png'
import imgPersonajeZonaV from '../../../assets/images/personajeV.png'
import { LOCALE } from '../../../constants/activity-constants'

import './homePersonajes.scss'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const HomePersonajes = props => {
  const { setTypeView, typeView } = props

  const [orderPersonajes, setOrderPersonajes] = useState({
    penis: {
      left: `5%`,
      //   top: `5%`,
      bottom: '-49px',
      transform: 'scale(0.75)',
      zIndex: 2,
      width: '70%',
    },
    menstruacion: { left: `35%`, transform: 'scale(0.63)', zIndex: 1 },
    zonaV: {
      left: `60%`,
      bottom: '-49px',
      transform: 'scale(0.64)',
      zIndex: 0,
    },
  })

  const onHandleClick = personaje => {
    setTypeView(personaje)
    if (personaje === 'penis') {
      setOrderPersonajes({
        penis: {
          left: `5%`,
          //   top: `5%`,
          bottom: '-49px',
          transform: 'scale(0.75)',
          zIndex: 2,
          width: '70%',
        },
        menstruacion: { left: `35%`, transform: 'scale(0.63)', zIndex: 1 },
        zonaV: {
          left: `60%`,
          bottom: '-49px',
          transform: 'scale(0.64)',
          zIndex: 0,
        },
      })
    } else if (personaje === 'menstruacion') {
      setOrderPersonajes({
        penis: {
          left: `60%`,
          bottom: '-35px',
          zIndex: 0,
          transform: 'scale(0.75)',
        },
        menstruacion: {
          left: `5%`,
          bottom: '-49px',
          transform: 'scale(0.73)',
          width: '40%',
          zIndex: 2,
        },
        zonaV: {
          left: `35%`,
          bottom: '-49px',
          transform: 'scale(0.55)',
          zIndex: 1,
        },
      })
    } else {
      setOrderPersonajes({
        penis: {
          left: `35%`,
          transform: 'scale(0.75)',
          zIndex: 1,
          bottom: -10,
        },
        menstruacion: {
          left: `60%`,
          transform: 'scale(0.64)',
          zIndex: 0,
          bottom: -40,
        },
        zonaV: {
          left: `5%`,
          transform: 'scale(0.6)',
          zIndex: 2,
          width: '40%',
          bottom: -100,
        },
      })
    }
  }

  const [imgBasePersonaje, setImgBasePersonaje] = useState(imgBasePenis)

  useEffect(() => {
    if (typeView === 'penis') {
      setImgBasePersonaje(imgBasePenis)
    } else if (typeView === 'menstruacion') {
      setImgBasePersonaje(imgBaseMenstruacion)
    } else if (typeView === 'zonaV') {
      setImgBasePersonaje(imgBaseZonaV)
    }
  }, [typeView])

  return (
    <div className={'f-personajes'}>
      <div className="f-personajes__container">
        <figure
          style={orderPersonajes.penis}
          onClick={() => onHandleClick('penis')}
        >
          <img src={imgPersonajePenis} alt="Imagen base" />
        </figure>
        <figure
          style={orderPersonajes.menstruacion}
          onClick={() => onHandleClick('menstruacion')}
        >
          <img src={imgPersonajeMenstruacion} alt="Imagen base" />
        </figure>
        <figure
          style={orderPersonajes.zonaV}
          onClick={() => onHandleClick('zonaV')}
        >
          <img src={imgPersonajeZonaV} alt="Imagen base" />
        </figure>
      </div>
      <figure>
        <img src={imgBasePersonaje} alt="Imagen base" />
      </figure>
      <span
        className={
          'f-personajes__info ' +
          (typeView ? 'f-personajes__info--' + typeView : '')
        }
      >
        {LOCALE === 'es-AR'
          ? '¡Hacé click sobre cada personaje y descubrí qué pasa!'
          : '¡Haz clic sobre cada personaje y descubre qué pasa!'}
      </span>
      <span
        className="f-personajes__buttonJugar"
        onClick={() => {
          pushEventDataLayer('Personajes :: Inicio', 'Click :: '+typeView, '¡A JUGAR!')
          navigate('/juegos')
        }}
      />
    </div>
  )
}

export default HomePersonajes
